/** @format */

// This is code generated automatically by the proto2api, please do not modify

export enum Error {
  Success = 0,
  // 非预期错误
  Unexpected = 1,
  InvalidParams = 400,
  NoAuth = 401,
  NoPermission = 403,
  Internal = 500,
  // 无效的 trace_id
  IllegalTraceId = 701,
  // 操作频繁
  FrequentOperation = 702,
  // 自定义状态吗 4 位数起
  InvalidDocumentKind = 1001,
  // 证件识别超时
  DocumentRecognizeTimeout = 1002,
  // 证件无法识别
  DocumentUnRecognize = 1003,
  // 证件识别出错
  DocumentUnRecognizeFailed = 1004,
  // 证件过期
  DocumentExpired = 1005,
  // Checkin
  CannotCheckIn = 2001,
}
